import { render, staticRenderFns } from "./CreateOrUpdateStudent.vue?vue&type=template&id=6d2b1648&"
import script from "./CreateOrUpdateStudent.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdateStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports